// src/pages/Home.js
import React from "react";
import { motion } from "framer-motion";
import Dashboard from "../components/Dashboard";


const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      <Dashboard />
    </motion.div>
  );
};

export default Home;